import axios from "axios";
import { API_URL } from "@/config";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/allergens`, { params: criteria });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, allergenId) {
      const response = await axios.get(`${API_URL}/allergens/${allergenId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, allergenData) {
      const response = await axios.post(`${API_URL}/allergens`, allergenData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { allergenId, allergenData }) {
      const response = await axios.put(`${API_URL}/allergens/${allergenId}`, allergenData);

      if (response.status !== 200 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, allergenId) {
      const response = await axios.delete(`${API_URL}/allergens/${allergenId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async getManyAllergensGroups(_, criteria) {
      const response = await axios.get(`${API_URL}/allergens/groups`, { params: criteria });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOneAllergensGroup(_, allergensGroupId) {
      const response = await axios.get(`${API_URL}/allergens/groups/${allergensGroupId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async createAllergensGroup(_, allergensGroupData) {
      const response = await axios.post(`${API_URL}/allergens/groups`, allergensGroupData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async updateAllergensGroup(_, { allergensGroupId, allergensGroupData }) {
      const response = await axios.put(
        `${API_URL}/allergens/groups/${allergensGroupId}`,
        allergensGroupData,
      );

      if (response.status !== 200 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async deleteAllergensGroup(_, allergensGroupId) {
      const response = await axios.delete(`${API_URL}/allergens/groups/${allergensGroupId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};
